import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { getToAuthorize } from './api'

const onError = (error: Error) => {
  console.log(error)
}

const useToAuthorize = () => {
  const { data, isLoading } = useQuery([QUERY_KEYS.TO_AUTHORIZE], getToAuthorize, {
    onError,
    refetchInterval: 15 * 60 * 1000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  })

  return { data, isLoading }
}

export { useToAuthorize }
